/** Positive catalog `length` caps input; `0` / empty means unlimited. */
export function resolveTextFieldMaxLength(length: unknown): number | null {
  const n = Number(length)
  return Number.isFinite(n) && n > 0 ? n : null
}
